// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YBFpQSdaQp9PADLXhB87 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 40vh;
    text-align: center;
}

.co43rEx47M3eWOzA9waR {
    width: 100%;
    max-width: 28rem;
}

.nrpHBAuamILjTRe_vthU {
    color: var(--color-primary-black);
    text-decoration: underline;
    cursor: pointer;
    display: inline-block;
    font-size: 1rem;
    line-height: 1.5;
    padding: 0;
    border: 0;
    background: none;
}

.nrpHBAuamILjTRe_vthU:visited {
    color: var(--color-primary-black);
}

.nrpHBAuamILjTRe_vthU:focus {
    outline: none;
}

.nrpHBAuamILjTRe_vthU:focus-visible {
    outline: none;
}`, "",{"version":3,"sources":["webpack://./src/features/auth/components/ForbiddenCountryError/ForbiddenCountryError.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;IAC1B,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".main {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: 40vh;\n    text-align: center;\n}\n\n.errorContainerInner {\n    width: 100%;\n    max-width: 28rem;\n}\n\n.backLink {\n    color: var(--color-primary-black);\n    text-decoration: underline;\n    cursor: pointer;\n    display: inline-block;\n    font-size: 1rem;\n    line-height: 1.5;\n    padding: 0;\n    border: 0;\n    background: none;\n}\n\n.backLink:visited {\n    color: var(--color-primary-black);\n}\n\n.backLink:focus {\n    outline: none;\n}\n\n.backLink:focus-visible {\n    outline: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `YBFpQSdaQp9PADLXhB87`,
	"errorContainerInner": `co43rEx47M3eWOzA9waR`,
	"backLink": `nrpHBAuamILjTRe_vthU`
};
module.exports = ___CSS_LOADER_EXPORT___;
